import { render, staticRenderFns } from "./GenericCreateUpdateMSListCard.vue?vue&type=template&id=70fa605a&scoped=true"
import script from "./GenericCreateUpdateMSListCard.vue?vue&type=script&lang=js"
export * from "./GenericCreateUpdateMSListCard.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/CU_artist.css?vue&type=style&index=0&id=70fa605a&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fa605a",
  null
  
)

export default component.exports